var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnswer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16274_11953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.375 0H2.625C1.17731 0 0 1.17731 0 2.625V14.4375C0 15.8852 1.17731 17.0625 2.625 17.0625H9.84375V20.3438C9.84375 20.6089 10.0032 20.8484 10.2487 20.9501C10.33 20.9836 10.4153 21 10.5 21C10.6706 21 10.8386 20.9331 10.964 20.8077L14.7092 17.0625H18.375C19.8227 17.0625 21 15.8852 21 14.4375V2.625C21 1.17731 19.8227 0 18.375 0ZM19.6875 14.4375C19.6875 15.1613 19.0988 15.75 18.375 15.75H14.4375C14.2629 15.75 14.0962 15.8189 13.9735 15.9423L11.1562 18.7596V16.4062C11.1562 16.044 10.8629 15.75 10.5 15.75H2.625C1.90116 15.75 1.3125 15.1613 1.3125 14.4375V2.625C1.3125 1.90116 1.90116 1.3125 2.625 1.3125H18.375C19.0988 1.3125 19.6875 1.90116 19.6875 2.625V14.4375Z",
    fill: "#262738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0941 4.32073C10.9865 4.08842 10.7542 3.93945 10.4982 3.93945C10.2423 3.93945 10.01 4.08842 9.90234 4.32073L5.96484 12.852L7.15659 13.4019L8.496 10.5006H12.5011L13.8398 13.4019L15.0316 12.852L11.0941 4.32073ZM9.10172 9.18814L10.4982 6.16152L11.8947 9.18814H9.10172Z",
    fill: "#262738"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16274_11953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswer);
export default __webpack_public_path__ + "static/media/answer.5a78836c36985dbe5d337ef3315ffaef.svg";
export { ForwardRef as ReactComponent };